/* eslint-disable */
import React from 'react'
import { NavLink } from 'react-router-dom'
import { renderRoutes } from 'react-router-config'
import { object, func, any } from 'prop-types'
import { connect } from 'react-redux'

import { withContext } from '../../../utils/withContext'
import styles from './WorkoutPage.styl'

class WorkoutPage extends React.Component {

	static fetchQueries = [
		'athletes/profile'
	]

	static propTypes = {
		dispatch: func,
		context: object,
		route: object,
		fetchAction: func
	}
	render() {
		const { route, dispatch, fetchAction, athlete, context: { i18n, createLocaleLink } } = this.props
		return (
			<main className={ styles.main } >
				<div className={ styles['content'] }>
					<ul>
						<li><NavLink activeClassName={ styles['active'] } to={ createLocaleLink("/apt/workout/daily") }>{ i18n`daily_label` }</NavLink></li>
						<li><NavLink activeClassName={ styles['active'] } to={ createLocaleLink("/apt/workout/weekly") }>{ i18n`weekly_label` }</NavLink></li>
						<li><NavLink activeClassName={ styles['active'] } to={ createLocaleLink("/apt/workout/results") }>{ i18n`results_label` }</NavLink></li>
					</ul>
				</div>
				{ !((athlete || {}).subscriptions || []).find(v => v.isActive) ? < div className={ styles['plan-waring'] }>
					<h2>{ i18n`no_plan_label` }</h2>
				</div> : null }
				{ renderRoutes(route.routes, { dispatch, fetchAction }) }
			</main >
		)
	}
}

const mapStateToProps = state => ({
	athlete: state.fetch.results[WorkoutPage.fetchQueries[0]]
})

export default withContext(connect(mapStateToProps)(WorkoutPage))





// WEBPACK FOOTER //
// ./src/client/webapp/pages/WorkoutPage/WorkoutPage.js